import React, { Suspense } from 'react';
import styled from 'styled-components';
// import assets
import loader from "../assets/sr-loader.gif";

const SuspenseWrapperElement = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoaderGif = styled.img`
  width: 100px;
  height: 100px;
  margin-left: 30px;
  margin-bottom: 45vh;
`;

export function Loader() {
  return (
    <SuspenseWrapperElement>
      <LoaderGif src={loader} alt="loader" />
    </SuspenseWrapperElement>
  )
}

export default function SuspenseWrapper({ children }) {
  return (
    <Suspense fallback={<Loader />}>
      {children}
    </Suspense>
  )
}
